/** Hands a downloaded file to the browser to save under `filename`. */
export function saveFile(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Let the click start the download before the URL goes away.
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
